<template>
  <div>
    <Header
      :disabled="disabled"
      @openDetailDialog="openDetailDialog"
      @batchDel="batchDel"
      ref="tableHeader"
    />
    <Main
      :loading="loading"
      :tableData="tableData"
      :disabled="disabled"
      :tableHeight="tableHeight"
      @reload="getData"
      @batchDel="submitDel"
      @openDetailDialog="openDetailDialog"
      ref="tableMain"
    />
    <GoodsCuttingEditDialog
      :disabled="goodsCuttingEditDialogParams.disabled"
      :visible="goodsCuttingEditDialogParams.visible"
      :title="goodsCuttingEditDialogParams.title"
      :techGoodsCuttingCode="goodsCuttingEditDialogParams.code"
      @reload="getData()"
      @close="() => (goodsCuttingEditDialogParams.visible = false)"
      :techGoodsSpecCode="techGoodsSpecCode"
    />
  </div>
</template>
<script>
import Main from './main.vue'
import Header from './header.vue'
import GoodsCuttingEditDialog from '../components/edit-form/dialog.vue'
export default {
  components: { Main, Header, GoodsCuttingEditDialog },
  props: {
    disabled: { type: Boolean, default: false },
    techGoodsSpecCode: { type: String, default: '' },
    tableHeight: { type: Number, default: 200 },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      goodsCuttingEditDialogParams: {
        visible: false,
        title: '',
        disabled: false,
        code: '',
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.techGoodsSpecCode) return
      this.loading = true
      this.$api
        .techGoodsCuttingListApi({
          techGoodsSpecCode: this.techGoodsSpecCode,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
    },
    openDetailDialog({ type, code = '' }) {
      const types = {
        add:
          this.$l('dialog_title_add_cut_size_information') ||
          '添加开料尺寸信息',
        edit:
          this.$l('dialog_title_edit_cut_size_information') ||
          '编辑开料尺寸信息',
        detail:
          this.$l('dialog_title_cut_size_information_detail') || '开料尺寸详情',
      }
      this.goodsCuttingEditDialogParams = {
        visible: true,
        title: types[type],
        code,
        disabled: type === 'detail',
      }
    },
    batchDel() {
      const listCode = this.$refs.tableMain.getCheckboxRecords()
      if (listCode) this.submitDel(listCode)
    },
    submitDel(listCode) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api.techGoodsCuttingDelApi({ listCode }).then(() => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
            type: 'success',
          })
          this.getData()
        })
      })
    },
  },
}
</script>
